module.exports = __webpack_public_path__ + "static/opis-inwestycji-b481179b1d18b2b8378f7ff9971dad01.jpg";